import { api } from "../AxiosInstance";

export function driverLogApi(params) {
  return api().get("/api/DriverLog/Get", {params});
}

export function driverLogCorrdinateApi(params) {
    return api().get("/api/PlanService/GetChangeLocationHistoryData", {params});
}

export function downloadChangeLocationHistoryApi() {
    return api().get("/api/PlanService/GetPlanChangeStatusesExcel");
}

export function updateChangeLocationStatusApi(data) {
    return api().post("/api/PlanService/UpdateChangeLocationHistoryDataStatuses", data);
}